import { useState, useLayoutEffect } from 'react';
import { isDesktop } from './helpers';

const useIsDesktopSize = () => {
    const [isDesktopSize, setIsDesktopSize] = useState(true);

    useLayoutEffect(() => {
        const handleResize = () => {
            setIsDesktopSize(isDesktop());
        };

        handleResize();
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return isDesktopSize;
};

export default useIsDesktopSize;
